<div id="baselineTexd" #id>    
    <div class="scrollbar" id="style-1" style="min-width: 300px !important;">
        <div class="force-overflow">
            <div class="file-browser">
                <ul>
                    <li *ngFor="let tenant of tenantList;let t=index" class="folder-tenant"
                        onclick="event.stopPropagation()"
                        (click)="tenant['active']=!tenant['active']"
                        [ngClass]="toggleTenant(tenant['active'])">
                        <!-- ="this.classList.toggle('folder-open')" -->                        
                        {{tenant.tenantName}}
                            <ul>
                                <li class="folder-baseline"
                                *ngFor="let baseline of tenant.baseLines"
                                onclick="event.stopPropagation()"
                                (click)="baseline['active']=!baseline['active']"
                                [ngClass]="toggleBaseline(baseline['active'])"
                                >
                                    &nbsp;
                                    <a (click)="onSelect($event,1, baseline,tenant)">{{baseline.baselineName}}</a>
                                    
                                        <ul>
                                            <li *ngFor="let simulation of baseline.simulatons" class="file"
                                                (click)="onSelect($event,2, baseline,tenant,simulation)">
                                                {{simulation.simulationName}}
                                            </li>
                                        </ul>                                    
                                </li>
                            </ul>                        
                    </li>
                </ul>
            </div>
            <br>
        </div>
    </div>
</div>